import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
import { useMutation } from '@apollo/client/react'
import { InjectedFormProps, reduxForm, SubmissionError } from 'redux-form'
// constants
import { Forms } from 'constants/forms'
// components
import { ReduxInput } from 'components/FormElements'
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE, ErrorMessage } from 'components/UI'
// graphql
import { USER_UPDATE_MUTATION } from 'graphql/user/mutations'
// utils
import { password, required } from 'utils/validators'
import { parseGraphQLErrorMessages } from 'utils/errors/parsers'

const Form = styled.form`
  display: flex;
  flex-direction: column;

  & > :last-child {
    margin-top: 40px;
  }
`

interface Props {
  hideModal: () => void
}

const PasswordChangeForm: React.FC<InjectedFormProps<any, Props> & Props> = ({ error, hideModal, handleSubmit }) => {
  const router = useRouter()

  const [updateUserMutation] = useMutation(USER_UPDATE_MUTATION)

  const onFormSubmit = async (data: { password: string }) => {
    try {
      await updateUserMutation({
        variables: {
          id: router.query.id as string,
          companyId: router.query.companyId as string,
          user: {
            password: data.password
          }
        }
      })

      hideModal()
    } catch (e) {
      console.log('[PasswordChangeModal.onFormSubmit]: ', parseGraphQLErrorMessages(e))
      throw new SubmissionError({ _error: parseGraphQLErrorMessages(e) })
    }
  }

  return (
    <Form onSubmit={handleSubmit(onFormSubmit)}>
      <ReduxInput label='Password' name='password' type='password' validate={[required, password]} />

      {error && <ErrorMessage>{error}</ErrorMessage>}

      <Button type='submit' layout={BUTTON_LAYOUTS.PURPLE} style={CREATE_BUTTON_STYLE}>
        Save
      </Button>
    </Form>
  )
}

export default reduxForm<any, Props>({
  form: Forms.USER_PASSWORD_EDIT_FORM,
  enableReinitialize: true
})(PasswordChangeForm)
